import { render, staticRenderFns } from "./PendingsV2.vue?vue&type=template&id=23ecd62c"
import script from "./PendingsV2.vue?vue&type=script&lang=js"
export * from "./PendingsV2.vue?vue&type=script&lang=js"
import style0 from "./PendingsV2.vue?vue&type=style&index=0&id=23ecd62c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QSpinner});
